let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("bVkeD")]).then(() => parcelRequire('3q9Jm'));